<template>
  <div >
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('product_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.data')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-productdata-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>{{ item['name'] }}</td>

              <td><strong>{{ $t('global.value') }}</strong></td>
              <td>{{ item['value'] }}</td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ProductData';



export default {
  name: 'ProductDataShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('productdata', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('productdata', ['find'])
  },
  methods: {
    ...mapActions('productdata', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  },
};
</script>
